const validate = (values) => {
    const errors = {};
   
    if (!values.name) {
        errors.name = "Name field shouldn’t be empty";
    } else if (values && values.name && values.name.length < 3) {
        errors.name = "Enter a minimum of three characters";
    }

    if (!values.description) {
        errors.description = "Description field shouldn’t be empty";
    }

    // if (!values.requestType) {
    //   errors.requestType = "Please select request type";
    // }
    if (!values.cardProgram) {
        errors.cardProgram = "Please select a card program";
    }

    if (!values.cardScheme) {
        errors.cardScheme = "Please select a card scheme";
    }
    if (!values.cardProfileCode) {
        errors.cardProfileCode = "Please select a card profile code";
    }
    if (!values.emvProfileCode) {
        errors.emvProfileCode = "Please select a emv profile code";
    }
    /* if (!values.scpCardProgram) {
    errors.scpCardProgram = "Please select a scp card program";
  } */

    if (!values.persoCode) {
        errors.persoCode = "Please select a perso code";
    }

    if (!values.persoFormatCode) {
        errors.persoFormatCode = "Please select a perso format code";
    }

    if (!values.pinGenerationMethod) {
        errors.pinGenerationMethod = "Please select a pin generation method";
    }
    if (values && values.defaultPinValue && values.defaultPinValue.length > 4) {
       
        errors.defaultPinValue = "Enter a maximum of four characters";
    }
    // if (!values.autoUploadPerso) {
    //   errors.autoUploadPerso = "Please select a scp card program";
    // }
    return errors;
};

export default validate;
